// Backend
import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';

// Functionality
import { useNavigate } from 'react-router-dom';

// Components
import { Header } from '../../constants/SharedComponents';
import { useDemoContext } from '../../contexts/DemoContext';

export function DemoTeamMemberPrepResults() {
  const navigate = useNavigate();
  const { demoData, updateDemoData, updateDemoPhase, addCompletedConversation } = useDemoContext();
  
  const handleComplete = () => {
    // Create a completed conversation entry that matches the demo data structure
    const completedConversation = {
      id: 'demo-completed-' + Date.now(),
      organiserName: 'Jane Smith', // Demo manager
      attendeeName: 'You (Demo User)', // The user who completed prep
      attendeeEmail: 'demo.user@company.com',
      isOrganiserManager: true, 
      isUserManager: false, // Set to false so the Start button does NOT appear for completed prep
      isCanvasData: false,
      status: 2, // Complete - conversation is ready but no Start button for team member
      employeePrepStatus: 2, // Complete - this will show "Edit" button in preparation column
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      isDemo: true
    };

    // Add the completed conversation to the demo context
    addCompletedConversation(completedConversation);

    // Update demo context to mark the prep as complete
    updateDemoData({
      ...demoData,
      currentStep: 'prep-complete',
      hasCompletedPrep: true
    });

    // Update demo phase
    updateDemoPhase('prep-complete');

    // Navigate back to demo conversations dashboard to see the completed conversation
    navigate('/demo/conversations');
  };

  return (
    <>
      <Header />
      <div className="grid-container">
        <Grid className="grid-padding-x">
          <Cell small={12}>
            <div className="page-content">
              <div className="page-content__header">
                <h1 className="page-content__title">Team Member Prep - Complete</h1>
                <p className="page-content__subtitle">
                  Thank you for completing your preparation for the conversation.
                </p>
              </div>

              <div style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '30px', 
                borderRadius: '8px', 
                marginBottom: '30px',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  backgroundColor: 'var(--color--brand-secondary);',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px auto'
                }}>
                  <svg 
                    width="40" 
                    height="40" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="white" 
                    strokeWidth="3" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <polyline points="20,6 9,17 4,12"></polyline>
                  </svg>
                </div>

                <h2 style={{ 
                  color: '#3F3F3F',
                  marginBottom: '20px',
                  fontSize: '24px'
                }}>
                  Preparation Complete!
                </h2>

                <p style={{ 
                  fontSize: '16px',
                  color: '#6c757d',
                  marginBottom: '30px',
                  lineHeight: '1.6'
                }}>
                  You have successfully completed your preparation for the conversation with your manager. 
                  Your responses have been processed and your priority topics have been identified.
                </p>

                <div style={{
                  backgroundColor: '#e8f5e8',
                  padding: '15px',
                  borderRadius: '6px',
                  marginBottom: '20px',
                  border: '1px solid #d4edda'
                }}>
                  <p style={{ 
                    fontSize: '14px',
                    color: '#155724',
                    marginBottom: '10px',
                    fontWeight: '500'
                  }}>
                    📋 <strong>Demo Mode:</strong> This is a demonstration of the team member preparation process. 
                    In the real application, your responses would be saved and available for your conversation with your manager.
                  </p>
                  <p style={{ 
                    fontSize: '14px',
                    color: '#155724',
                    marginBottom: '0',
                    fontWeight: '500'
                  }}>
                    🎯 <strong>Next:</strong> When you complete this prep, you'll see a new conversation in your dashboard with "Complete" preparation status and a "Start" button to begin the conversation canvas.
                  </p>
                </div>

                <button
                  onClick={handleComplete}
                  className="page-content__button--medium"
                  style={{
                    backgroundColor: 'var(--color--brand-secondary);',
                    color: '#FFFFFF',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                >
                  Complete Prep & View Dashboard
                </button>
              </div>
            </div>
          </Cell>
        </Grid>
      </div>
    </>
  );
}
